import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ children }) {
  const { token, initializing } = useAuth();

  if (initializing) {
    return <p style={{ color: '#999', padding: 24 }}>Loading...</p>;
  }

  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}
